import FilterTemplatePage from './components/FilterTemplatePage';

const routes = [
  {
    path: '/filter-template',
    name: 'menu.filter-template',
    icon: 'filter',
    customIcon: true,
    loginRequired: true,
    component: FilterTemplatePage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
